<template>
  <div class="box">
    <el-row :gutter="10">
      <el-col :span="7">
        <el-select
          style="width: 100%"
          clearable
          filterable
          size="small"
          v-model="searchData.releaseStatus"
          placeholder="审核状态"
        >
          <el-option
            v-for="item in closedBetaAduitList"
            :key="item.key"
            :value="item.key"
            :label="item.value"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="10">
        <el-input
          style="width: 100%"
          size="small"
          v-model="searchData.keyword"
          class="input-with-select"
          placeholder="请输入搜索内容"
        >
          <el-select
            size="small"
            slot="prepend"
            v-model="searchData.chooseType"
            placeholder="请选择类型"
          >
            <el-option label="内测ID" :value="1"></el-option>
            <!-- <el-option label="APPID" :value="2"></el-option> -->
            <el-option label="应用名称" :value="3"></el-option>
            <el-option label="开发者名称" :value="4"></el-option>
            <el-option label="审核员" :value="5"></el-option>
          </el-select>
        </el-input>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" :gutter="10">
      <el-col :span="12">
        <el-row type="flex" align="middle">
          <span style="white-space: nowrap"> 提交日期：</span>
          <el-date-picker
            size="small"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            v-model="searchData.submitDate"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker> </el-row
      ></el-col>
      <el-col>
        <el-button size="small" type="primary" @click="getclosedBetaList"
          >搜索</el-button
        >
      </el-col>
    </el-row>
    <PageTable
      :columns="columns"
      :tableData="tableData"
      @page-change="handleChangePage"
      @selection-change="handleSelectionChange"
    >
      <!-- <el-table-column
        slot="prefix"
        :selectable="selectableRow"
        type="selection"
        width="55"
      >
      </el-table-column> -->
      <template slot-scope="{ row }" slot="operation">
        <div>
          <span
            v-has="'lookinfo'"
            class="colorGreen pointer mr10"
            @click="handleOperate('lookinfo', row)"
            >查看</span
          >
          <!-- <el-button
            type="text"
            v-has="'downloadAPK'"
            @click="handleOperate('download', row)"
            :disabled="!row.apkUrl"
            >评测apk包</el-button
          > -->
          <el-button
            class="colorRed pointer"
            v-has="'review'"
            type="text"
            :disabled="!reviewList.includes(row.releaseStatus)"
            @click="handleOperate('review', row)"
            >审核</el-button
          >
        </div>
      </template>
      <template slot-scope="{ row }" slot="auditStatus">
        <span>{{ row.releaseStatus | typeDesc(closedBetaAduitList) }}</span>
      </template>
    </PageTable>
    <!-- <div class="page-foot" v-has="'reviewBatch'">
      <el-select
        v-model="batchOperation"
        size="small"
        class="mr10"
        placeholder="批量操作"
      >
        <el-option :value="1" label="审核通过"></el-option>
        <el-option :value="2" label="审核不通过"></el-option>
      </el-select>
      <el-button size="small" type="primary" @click="handleBatchOperation"
        >提交操作</el-button
      >
    </div> -->
    <el-dialog title="内测申请" :visible.sync="dialogFormVisible" center>
      <viewDetail
        :closeBetaInfo="closeBetaInfo"
        :propReleaseArea="releaseArea"
      ></viewDetail>
    </el-dialog>
    <el-dialog
      center
      title="内测审核"
      destroy-on-close
      :visible.sync="dialogAuditVisible"
    >
      <auditModel
        v-if="dialogAuditVisible"
        :checkData="checkData"
        @submitAudit="submitAudit"
      ></auditModel>
    </el-dialog>
  </div>
</template>

<script>
import {
  closedBetaList,
  getLanguageList,
  lookcloseBetaInfo,
  closeBetaAuditList,
} from "@/common/js/api";
import { closedBetaAduitList } from "@/common/constant/constant.js";
import PageTable from "@/components/PageTable.vue";
import viewDetail from "./viewDetail.vue";
import auditModel from "./auditModel.vue";
import storage from "@/common/utils/storage";
import moment from "moment";
export default {
  name: "closedBeta",
  components: {
    PageTable,
    viewDetail,
    auditModel,
  },
  data() {
    let end = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
    let start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    start = moment(start).format("YYYY-MM-DD HH:mm:ss");
    return {
      languageList: [],
      searchData: {
        languageId: "",
        submitDate: [start, end],
        releaseStatus: "",
        chooseType: 3,
        keyword: "",
        count: true,
      },
      columns: [
        {
          key: "id",
          label: "内测ID",
          align: "center",
          width: 120,
          "show-overflow-tooltip": true,
        },
        {
          key: "appId",
          label: "APPID",
          align: "center",
          width: 100,
          "show-overflow-tooltip": true,
        },
        {
          key: "title",
          label: "应用名称",
          align: "center",
          width: 120,
          "show-overflow-tooltip": true,
        },
        {
          key: "packageName",
          label: "应用包名",
          align: "center",
          width: 120,
          "show-overflow-tooltip": true,
        },
        {
          key: "creatorName",
          label: "开发者名称",
          align: "center",
          width: 140,
          "show-overflow-tooltip": true,
        },
        {
          key: "submitDate",
          label: "提交时间",
          align: "center",
          width: 140,
          "show-overflow-tooltip": true,
        },
        {
          key: "reviewDate",
          label: "审核时间",
          align: "center",
          width: 140,
          "show-overflow-tooltip": true,
        },
        {
          key: "countryNum",
          label: "发布国家/地区",
          width: "150px",
          align: "center",
          "show-overflow-tooltip": true,
        },
        {
          key: "name",
          label: "审核员",
          align: "center",
          "show-overflow-tooltip": true,
        },
        {
          slot: "auditStatus",
          label: "审核状态",
          align: "center",
          width: 140,
          "show-overflow-tooltip": true,
        },
        {
          slot: "operation",
          label: "操作",
          width: "100px",
          align: "center",
          fixed: "right",
        },
      ],
      tableData: {
        page: 1,
        size: 10,
        total: 0,
        list: [],
      },
      closedBetaAduitList,
      dialogFormVisible: false, //查看
      dialogAuditVisible: false, //审核
      batchOperation: 1,
      selectionData: [],
      checkData: {},
      closeBetaInfo: {},
      releaseArea: [],
      reviewList: [700], // 可审核的状态列表
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    selectableRow(row) {
      if (!this.reviewList.includes(row.releaseStatus)) return false;
      return true;
    },
    init() {
      this.getLanguageList();
      this.getclosedBetaList();
    },
    submitAudit() {
      this.dialogAuditVisible = false;
      this.init();
    },

    handleChangePage({ page, size }) {
      this.getclosedBetaList({ page, size });
    },
    handleSelectionChange(selection) {
      this.selectionData = selection;
    },
    async getclosedBetaList(params) {
      let reqParsms = {
        page: 1,
        size: 10,
        ...this.searchData,
        ...params,
      };
      reqParsms.submitStartDate = reqParsms.submitDate
        ? reqParsms.submitDate[0]
        : "";
      reqParsms.submitOverDate = reqParsms.submitDate
        ? reqParsms.submitDate[1]
        : "";
      delete reqParsms.submitDate;
      const res = await closedBetaList(reqParsms);
      res.data.list.forEach((item) => {
        if (item.releaseCountry)
          item.countryNum = item.releaseCountry.split("|").length + "个";
      });
      this.tableData = res.data;
    },
    async getLanguageList() {
      const res = await getLanguageList();
      this.languageList = res.data;
    },
    async handleOperate(operationType, row) {
      this.checkData = row;
      if (operationType == "lookinfo") {
        this.lookcloseBetaInfo(row);
      } else if (operationType == "review") {
        this.dialogAuditVisible = true;
      } else if (operationType === "download") {
        window.open(row.apkUrl);
      }
    },
    async lookcloseBetaInfo(val) {
      let params = {
        testApplyId: val.id,
      };
      const res = await lookcloseBetaInfo(params);
      if (res && res.code === 0) {
        this.releaseArea = res.data.publishCountry.split("|").map((item) => {
          return Number(item);
        });
        this.closeBetaInfo = res.data;
        this.dialogFormVisible = true;
      }
    },
    async handleBatchOperation() {
      let releaseIds = this.selectionData.filter((item) => {
        return this.reviewList.includes(item.releaseStatus);
      });
      releaseIds = releaseIds.map((item) => item.releaseId);
      if (releaseIds.length == 0) {
        this.$message.error("请勾选需要操作的数据");
        return;
      }
      let params = {
        ids: releaseIds,
        reviewResult: this.batchOperation,
        resolveUserW3Id: storage.getUserInfo().userId,
      };
      let res = await closeBetaAuditList(params);
      if (res.code === 0) {
        this.$message.success("审核成功");
        this.init();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.input-with-select {
  /deep/.el-input-group__prepend {
    background: #fff;
    width: 80px;
  }
}
</style>
